/**
 * Helper that takes a date string in format as 2024-03-26T14:45:30.836Z and
 * returns a string in this format: 'March 26, 2024'
 */
export function formatDate(date: string): string {
  if (!date) return '';

  const newDate = new Date(date);
  return newDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
